import { Sequence } from "./Sequence";

export class EmailTemplate {
    subject: string;
    message: string;

    constructor(
        subject: string = '',
        message: string = ''
    ){
        this.subject = subject;
        this.message = message;
    }
}

export class Configuration {
    company_id: number;
    path: any;
    path_url: string;
    footer: string;
    footer_small: string;
    tax_type: string;
    sequences: Sequence[];
    email_template: EmailTemplate;
    hide_client_send_to_face: boolean;
    hide_client_send_to_faceb2b: boolean;
    hide_client_send_to_accounting: boolean;

    constructor(
        company_id: number = null,
        path: any = null,
        path_url: string = '',
        footer: string = '',
        footer_small: string = '',
        tax_type: string = 'iva',
        sequences: Sequence[] = [new Sequence()],
        email_template: EmailTemplate = new EmailTemplate(),
        hide_client_send_to_face: boolean = false,
        hide_client_send_to_faceb2b: boolean = false,
        hide_client_send_to_accounting: boolean = false
    ){
        this.company_id = company_id;
        this.path = path;
        this.path_url = path_url;
        this.footer = footer;
        this.footer_small = footer_small;
        this.tax_type = tax_type;
        this.sequences = sequences;
        this.email_template = email_template;
        this.hide_client_send_to_face = hide_client_send_to_face;
        this.hide_client_send_to_faceb2b = hide_client_send_to_faceb2b;
        this.hide_client_send_to_accounting = hide_client_send_to_accounting;
    }
}